import Debug from 'debug'
import { Vue } from 'vue-property-decorator';

const debug = Debug('child-component-store')

export class ChildComponents {

  private components: Vue[] = []

  constructor(private name: string) {}

  register(components: Vue[]) {
    debug(`registering ${components.length} components in '${this.name}'`, components.map(x => x.$options.name))

    this.components.push(...components)
  }

  destroy() {
    const components = [ ...this.components ]
    debug(`destroying ${components.length} components in '${this.name}'`, components.map(x => x.$options.name))
    for (let component of components) {
      component.$destroy()
      $(component.$el).remove()
    }
    this.components = []
  }
}
